import { z } from "zod";

export const requiredNumericString = (
	requiredMessage: string,
	invalidMessage: string,
) =>
	z
		.string()
		.min(1, requiredMessage)
		.transform((val) => Number(val))
		.refine((val) => !Number.isNaN(val), invalidMessage);

export const nullableNumberSchema = z
	.any()
	.transform((val) => {
		if (val === null || val === undefined || val === "") {
			return null;
		}
		const num = typeof val === "string" ? Number(val) : val;
		return Number.isNaN(num) ? null : num;
	})
	.pipe(z.number().nullable());

export const participationPercentageSchema = z
	.string()
	.min(1, "Le pourcentage de participation est obligatoire")
	.transform((val) => Number(val))
	.refine(
		(val) => !Number.isNaN(val),
		"Le pourcentage de participation doit être un nombre valide",
	)
	.refine(
		(val) => val >= 0,
		"Le pourcentage de participation doit être supérieur ou égal à 0",
	)
	.refine(
		(val) => val <= 100,
		"Le pourcentage de participation doit être inférieur ou égal à 100",
	)
	.refine(
		(val) => Number.isInteger(val * 100),
		"Maximum 2 décimales autorisées",
	);
